import React from 'react';
import { motion } from 'framer-motion';

const defaultVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0 },
};

const animationPresets = {
  'fade-up': {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0 },
  },
  'fade-down': {
    hidden: { opacity: 0, y: -15 },
    visible: { opacity: 1, y: 0 },
  },
  'fade-left': {
    hidden: { opacity: 0, x: -15 },
    visible: { opacity: 1, x: 0 },
  },
  'fade-right': {
    hidden: { opacity: 0, x: 15 },
    visible: { opacity: 1, x: 0 },
  },
  'scale-up': {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  },
  'fade': {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  },
};

const ScrollReveal = ({
  children,
  animation = 'fade-up',
  delay = 0,
  duration = 0.6,
  once = true,
  className = '',
  threshold = 0.15,
  as = 'div',
  staggerChildren,
}) => {
  const MotionComponent = motion[as] || motion.div;
  const variants = animationPresets[animation] || defaultVariants;

  return (
    <MotionComponent
      initial="hidden"
      whileInView="visible"
      viewport={{ once, amount: threshold }}
      variants={staggerChildren ? {
        hidden: {},
        visible: { transition: { staggerChildren: staggerChildren } },
      } : variants}
      transition={!staggerChildren ? { duration, delay, ease: 'easeOut' } : undefined}
      className={className}
    >
      {staggerChildren
        ? React.Children.map(children, (child) =>
            child ? (
              <motion.div variants={variants} transition={{ duration, ease: 'easeOut' }}>
                {child}
              </motion.div>
            ) : null
          )
        : children}
    </MotionComponent>
  );
};

export default ScrollReveal;
